import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { RoutingService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ArticleService } from '../../../core/catalog';
import { prepareUrlForLink } from '../../../core/util';

@Injectable({ providedIn: 'root' })
export class ShortProductRedirectGuard {
  constructor(private router: Router, private routingService: RoutingService, private articleService: ArticleService) {}

  canActivate(route: ActivatedRouteSnapshot, _routerState: RouterStateSnapshot): Observable<UrlTree | boolean> {
    return this.articleService.getArticle(route.params.articleCode).pipe(
      map((article) => {
        if (!article) {
          return this.handleNotFound();
        }

        return this.router.parseUrl(prepareUrlForLink(article.url));
      })
    );
  }

  private handleNotFound(): boolean {
    this.routingService.go({ cxRoute: 'notFound' });
    return false;
  }
}
